import BonusResult from "slotworks/model/gameplay/records/results/bonus-result";
import Result from "slotworks/model/gameplay/records/results/result";

abstract class Record {

    public creditsWon: number;

    public freespinsWon: number;

    public freespinsTriggered: boolean;

    public results: Result[] = [];

    public beenPaid = false;

    public getResultsOfType(resultType: typeof Result): Result[] {
        const toReturn: Result[] = [];

        for (const result of this.results) {
            if (result instanceof resultType) {
                toReturn.push(result);
            }
        }

        return toReturn;
    }

    public isBonusTriggered(id?: string): boolean {
        for (const result of this.results) {
            if (result instanceof BonusResult) {
                if (result.id === id && !result.played) {
                    return true;
                }
            }
        }

        return false;
    }

    public setBonusPlayed(id: string, played: boolean = true) {
        for (const result of this.results) {
            if (result instanceof BonusResult) {
                if (result.id === id) {
                    result.played = played;
                    break;
                }
            }
        }
    }
}

export default Record;



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/gameplay/records/record.ts